<template>
  <LoadingSpinner :loading="loading"> </LoadingSpinner>

  <div :class="panelMode ? 'p-3' :'container'">
    <div class="row">
      <div :class="panelMode ? 'col' : 'col-md'">
        <div class="mt-2 mb-4" :style="{ maxWidth: panelMode ? '100%' : '560px' }">
          <h3 style="padding-right: 60px">Legg til produkt i kategorien "{{category.name}}"</h3>

          <div class="bo_form-section mt-4">
          <div>
            <span v-if="item.itemType != 'DELIVERY_SERVICE'" class="bo_label">Navn</span>
            <span v-else class="bo_label">Leveringsområde</span>
            <input id="name" class="form-control" type="text" v-model="item.name" />
          </div>

          <div v-if="item.itemType == 'DELIVERY_SERVICE'">
            <span class="bo_label">Tillatte postnr (separer postnr med komma, f.eks: 2010,2040)</span>
            <input id="zipCodes" class="form-control" type="text" v-model="item.zipCodes" />
          </div>

          <div v-if="item.itemType == 'DISH' || item.itemType == 'DRINK_BUBBLE_TEA'">
            <span class="bo_label">Meny nummer</span>
            <input id="menuNr" class="form-control" type="text" v-model="item.menuNr" />
          </div>
          </div>

          <div v-if="showAvailabilitySection" class="bo_form-section">
          <div class="bo_form-section-title">Tilgjengelighet</div>
          <div v-if="hasMultiLocations()">
            <span class="ingredient-title">Tilgjengelig på følgende avdelinger</span>
            <fieldset>
              <label v-for="(location, index) in locations" :key="index" class="multiple-checkbox-label">
                <input type="checkbox" :name="location.name" :value="location.id" @click="setSelectedLocations" class="multiple-checkbox"
                       :checked="item.availableAtLocationIds.indexOf(location.id) > -1" /> {{ location.name }}
              </label>
            </fieldset>
          </div>

          <div v-if="showAvailableForChannels()">
            <span class="ingredient-title">Tilgjengelig på følgende kanaler</span>
            <fieldset>
              <label v-for="(channel, index) in availableChannels" :key="index" class="multiple-checkbox-label">
                <input type="checkbox" :name="channel.name" :value="channel.id" @click="setSelectedChannels" class="multiple-checkbox"
                       :checked="item.availableForChannelIds.indexOf(channel.id) > -1" /> {{ channel.name }}
              </label>
            </fieldset>
          </div>

          <div v-if="showAvailableForOrderTypes()">
            <span class="ingredient-title">Tilgjengelig for</span>
            <fieldset>
              <label v-for="(orderType, index) in orderTypes" :key="index" class="multiple-checkbox-label">
                <input type="checkbox" :name="orderType" :value="orderType" @click="setSelectedOrderTypes" class="multiple-checkbox"
                       :checked="item.availableForOrderTypes.indexOf(orderType) > -1" /> {{ getOrderTypeName(orderType) }}
              </label>
            </fieldset>
          </div>

          <div v-if="showAvailableOnDays()">
            <span class="ingredient-title">Tilgjengelig på følgende dager</span>
            <fieldset>
              <label v-for="(day, index) in days" :key="index" class="multiple-checkbox-label">
                <input type="checkbox" :name="day" :value="day" @click="setSelectedDays" class="multiple-checkbox"
                       :checked="item.availableOnDays.indexOf(day) > -1" /> {{ getDayName(day) }}
              </label>
            </fieldset>
          </div>

          <div v-if="enableShowAsDiscount()">
            <div class="form-switch-wrapper mt-3 mb-4">
              <label class="form-switch">
                <div class="form-switch-container">
                  <span class="bold me-2">Vis som tilbud</span>
                  <input type="checkbox" v-model="item.showAsDiscount" />
                  <i></i>
                </div>
              </label>
            </div>
          </div>

          </div>

          <div class="bo_form-section">
          <div class="bo_form-section-title">Presentasjon</div>
          <div>
            <span class="bo_label">Bilde</span>
            <input type="file" class="form-control" accept="image/png,image/jpeg,image/avif,image/webp" ref="file" @change="selectFile" />
          </div>

          <div>
            <span class="bo_label">Beskrivelse</span>
            <textarea id="description" class="form-control" type="text" v-model="item.description" rows="4" cols="50"></textarea>
          </div>

          </div>

          <div v-if="item.itemType == 'DISH' || item.itemType == 'DRINK_BUBBLE_TEA'" class="bo_form-section">
            <div class="bo_form-section-title">Varianter</div>
            <div class="text-muted">Enten ingen eller minst to varianter, f.eks størrelser.</div>
            <div class="row">
              <ul class="addedSubselections">
                <li v-for="(subselection, index) in item.subselections" :key="index" class="container mb-1">
                  <div v-if="subselection.id != editingSubselectionId" class="d-flex align-items-center"> <!-- show variant -->
                    <div>
                        <a class="remove-addOn-btn"
                           @click="removeSubselection(subselection)">
                          <img src="@/assets/images/remove.png" width="21" title="Slett variant"/>
                        </a>
                    </div>
                    <div>
                        <div class="bold">{{ subselection.name }}</div>
                        <div class="subselection-text" v-if="showTakeawayPriceFields">
                           Kr {{ getPriceWithVat(subselection.price) }} (med {{vat.takeOut}}% mva for Ta Med)
                        </div>
                        <div class="subselection-text" v-if="showDineInPriceFields">
                          Kr {{ getPriceDineIn(subselection.priceDineIn) }} (med {{vat.dineIn}}% mva for Spise Her)
                        </div>
                        <div class="subselection-text">
                            <div v-for="(addOnGroupId, index) in subselection.addOnGroupIds" :key="index">
                              {{ getAddOnGroup(addOnGroupId).name }}
                            </div>
                        </div>
                    </div>
                    <div>
                        <a @click="editSubselection(subselection)" class="icon-btn">
                          <img src="@/assets/images/edit.png" width="21" title="Rediger variant"/>
                        </a>
                    </div>
                  </div>
                  <div v-else class="editing-variant"> <!-- editing variant -->
                    <div class="col-sm-12 d-inline">
                      <input class="form-control" type="text" placeholder="Navn på variant" v-model="subselectionName" />
                    </div>
                    <div class="mt-2" v-if="showTakeawayPriceFields"><span class="ingredient-title">Pris ta med/takeaway</span></div>
                    <div class="row" v-if="showTakeawayPriceFields">
                      <div class="col-sm-6">
                        <input class="form-control" type="number" min="0" placeholder="Pris på variant" v-model="subselectionPrice" @input="updateSubselectionPriceWithVat()" />
                        <div class="text-muted">(uten MVA)</div>
                      </div>
                      <div class="col-sm-6">
                        <input class="form-control" type="number" min="0" placeholder="Pris på variant" v-model="subselectionPriceWithVat" @input="updateSubselectionPrice()" />
                        <div class="text-muted">(med MVA, {{ vat.takeOut }}%)</div>
                      </div>
                    </div>

                    <div v-if="showDineInPriceFields">
                      <div class="mt-2"><span class="ingredient-title">Pris spise her</span></div>
                      <div class="row">
                        <div class="col-sm-6">
                          <input class="form-control" type="number" min="0" placeholder="Pris på variant" v-model="subselectionPriceDineIn" @input="updateSubselectionPriceDineInWithVat()" />
                          <div class="text-muted">(uten MVA)</div>
                        </div>
                        <div class="col-sm-6">
                          <input class="form-control" type="number" min="0" v-model="subselectionPriceDineInWithVat" @input="updateSubselectionPriceDineIn()" />
                          <div class="text-muted">(med MVA, {{ vat.dineIn }}%)</div>
                        </div>
                      </div>
                      <div v-if="subselectionDineInPriceSuggestion" class="mt-1">
                        <a href="#" class="bo_suggestion-btn" @click.prevent="applySubselectionDineInPriceSuggestion">
                          Klikk for å bruke samme grunnpris som ta med: kr {{ subselectionDineInPriceSuggestion }} uten mva = kr {{ subselectionDineInPriceSuggestionWithVat }} med {{ vat.dineIn }}% mva
                        </a>
                      </div>
                    </div>

                    <div v-if="useAddOns">
                      <span>Grupper for valg og tillegg for denne varianten</span>
                      <fieldset class="mt-2 mb-4">
                        <label v-for="addOnGroup in addOnGroups" :key="'edit_' + addOnGroup.id" class="multiple-checkbox-label">
                          <input type="checkbox" :name="addOnGroup.name" :value="addOnGroup.id" @click="setSelectedSubselectionAddOnGroupIds" class="multiple-checkbox"
                                 :checked="subselectionAddOnGroupIds.indexOf(addOnGroup.id) > -1"/> {{ addOnGroup.name }}
                        </label>
                      </fieldset>
                    </div>
                    <div>
                      <button type="button" class="save-btn me-4" @click="cancelEditingSubselection"> Avbryt </button>
                      <button v-if="activateAddSubselectionButton" type="button" class="save-btn" @click="saveSubselection()"> Lagre variant </button>
                      <button v-else type="button" class="save-btn" disabled="true"> Lagre variant </button>
                    </div>
                  </div>
                </li>
              </ul>
            </div>
            <div v-if="editingSubselectionId == null" class="variant"> <!-- add variant -->
              <div class="col-sm-12 d-inline">
                <input class="form-control" type="text" placeholder="Navn på variant" v-model="subselectionName" />
              </div>
              <div class="mt-2" v-if="showTakeawayPriceFields"><span class="ingredient-title">Pris ta med/takeaway</span></div>
              <div class="row" v-if="showTakeawayPriceFields">
                <div class="col-sm-6">
                  <input class="form-control" type="number" min="0" placeholder="Pris på variant" v-model="subselectionPrice" @input="updateSubselectionPriceWithVat()" />
                  <div class="text-muted">(uten MVA)</div>
                </div>
                <div class="col-sm-6">
                  <input class="form-control" type="number" min="0" placeholder="Pris på variant" v-model="subselectionPriceWithVat" @input="updateSubselectionPrice()" />
                  <div class="text-muted">(med MVA, {{ vat.takeOut }}%)</div>
                </div>
              </div>
              <div v-if="showDineInPriceFields">
                <div class="mt-2"><span class="ingredient-title">Pris spise her</span></div>
                <div class="row">
                  <div class="col-sm-6">
                    <input class="form-control" type="number" min="0" placeholder="Pris på variant" v-model="subselectionPriceDineIn" @input="updateSubselectionPriceDineInWithVat()" />
                    <div class="text-muted">(uten MVA)</div>
                  </div>
                  <div class="col-sm-6">
                    <input class="form-control" type="number" min="0" placeholder="Pris på variant" v-model="subselectionPriceDineInWithVat" @input="updateSubselectionPriceDineIn()" />
                    <div class="text-muted">(med MVA, {{ vat.dineIn }}%)</div>
                  </div>
                </div>
                <div v-if="subselectionDineInPriceSuggestion" class="mt-1">
                  <a href="#" class="bo_suggestion-btn" @click.prevent="applySubselectionDineInPriceSuggestion">
                    Klikk for å bruke samme grunnpris som ta med: kr {{ subselectionDineInPriceSuggestion }} uten mva = kr {{ subselectionDineInPriceSuggestionWithVat }} med {{ vat.dineIn }}% mva
                  </a>
                </div>
              </div>

              <div v-if="useAddOns" class="mt-3">
                <span>Grupper for valg og tillegg for denne varianten</span>
                <fieldset class="mt-2 mb-4">
                  <label v-for="addOnGroup in addOnGroups" :key="'add_' + addOnGroup.id" class="multiple-checkbox-label">
                    <input type="checkbox" :name="addOnGroup.name" :value="addOnGroup.id" @click="setSelectedSubselectionAddOnGroupIds" class="multiple-checkbox"
                           :checked="subselectionAddOnGroupIds.indexOf(addOnGroup.id) > -1"/> {{ addOnGroup.name }}
                  </label>
                </fieldset>
              </div>
              <div>
                <button v-if="activateAddSubselectionButton" type="button" class="save-btn" @click="addSubselection"> Legg til variant </button>
                <button v-else type="button" class="save-btn" disabled="true"> Legg til variant </button>
              </div>
            </div>
          </div>

          <div v-if="item.subselections.length == 0" class="bo_form-section">
            <div class="bo_form-section-title">Pris</div>
            <div v-if="item.itemType == 'DELIVERY_SERVICE'" class="row">
              <div class="col-sm-6">
                <input class="form-control" type="number" min="0" v-model="priceDineIn" @input="updatePriceDineInWithVat()" />
                <div class="text-muted">(uten MVA)</div>
              </div>
              <!-- vat for delivery service is the same as dineIn vat -->
              <div class="col-sm-6">
                <input class="form-control" type="number" min="0" v-model="priceDineInWithVat" @input="updatePriceDineIn()" />
                <div class="text-muted">(med MVA for tjeneste, {{ vat.dineIn }}%)</div>
              </div>
            </div>
            <div v-else>
              <div v-if="item.itemType != 'DRINK_ALCOHOL'">
                <div class="mt-2" v-if="showTakeawayPriceFields"><span class="ingredient-title">Pris ta med/takeaway</span></div>
                <div class="row" v-if="showTakeawayPriceFields">
                  <div class="col-sm-6">
                    <input class="form-control" type="number" min="0" v-model="price" @input="updatePriceWithVat()" :disabled="item.openPrice" />
                    <div class="text-muted">(uten MVA)</div>
                  </div>
                  <div class="col-sm-6">
                    <input class="form-control" type="number" min="0" v-model="priceWithVat" @input="updatePrice()" :disabled="item.openPrice" />
                    <div class="text-muted">(med MVA, {{ vat.takeOut }}%)</div>
                  </div>
                </div>
              </div>
              <div v-if="showDineInPriceFields">
                <div class="mt-2"><span class="ingredient-title">Pris spise her</span></div>
                <div class="row">
                  <div class="col-sm-6">
                    <input class="form-control" type="number" min="0" v-model="priceDineIn" @input="updatePriceDineInWithVat()" :disabled="item.openPrice" />
                    <div class="text-muted">(uten MVA)</div>
                  </div>
                  <div class="col-sm-6">
                    <input class="form-control" type="number" min="0" v-model="priceDineInWithVat" @input="updatePriceDineIn()" :disabled="item.openPrice" />
                    <div class="text-muted">(med MVA, {{ vat.dineIn }}%)</div>
                  </div>
                </div>
                <div v-if="dineInPriceSuggestion" class="mt-1">
                  <a href="#" class="bo_suggestion-btn" @click.prevent="applyDineInPriceSuggestion">
                    Klikk for å bruke samme grunnpris som ta med: kr {{ dineInPriceSuggestion }} uten mva = kr {{ dineInPriceSuggestionWithVat }} med {{ vat.dineIn }}% mva
                  </a>
                </div>
              </div>
            </div>

            <div v-if="enableOpenPrice()" class="d-flex align-items-center mt-3">
              <div class="form-switch-wrapper">
                <label class="form-switch">
                  <div class="form-switch-container">
                    <span class="bold me-2">Åpen pris</span>
                    <input type="checkbox" v-model="item.openPrice" @change="onOpenPriceChanged" />
                    <i></i>
                  </div>
                </label>
              </div>
              <span v-if="item.openPrice" class="text-muted ms-3">
                Prisen settes ved bestilling. Derfor er prisen satt til 0 her.
              </span>
            </div>
          </div>

          <div v-if="(item.itemType == 'DISH' || item.itemType == 'DRINK_BUBBLE_TEA') && useAddOns" class="bo_form-section">
            <div class="bo_form-section-title">Valg og tillegg for hele produktet</div>
                <fieldset class="mt-2">
                  <label v-for="(addOnGroup, index) in addOnGroups" :key="index" class="multiple-checkbox-label">
                    <input type="checkbox" :name="addOnGroup.name" :value="addOnGroup.id" @click="setSelectedItemAddOnGroupIds" class="multiple-checkbox" /> {{ addOnGroup.name }}
                  </label>
                </fieldset>
          </div>

          <div v-if="item.itemType == 'DISH' || item.itemType == 'DRINK_BUBBLE_TEA'" class="bo_form-section">
            <div class="bo_form-section-title">Hvilke allergener inneholder dette?</div>
            <fieldset>
                <label v-for="(allergen, index) in allergens" :key="index" class="multiple-checkbox-label">
                  <input type="checkbox" :name="allergen.name" :value="JSON.stringify(allergen)" @click="setSelectedAllergens" class="multiple-checkbox"  /> {{ allergen.name }}
                </label>
            </fieldset>
          </div>

          <div v-if="showOtherSection" class="bo_form-section">
          <div class="bo_form-section-title">Annet</div>
          <div v-if="!allLocationsUseManualPickupTime && item.itemType && item.itemType != 'DELIVERY_SERVICE'">
            <span class="bo_label">Tilberedningstid (minutter)</span>
            <input id="prepTimeMinutes" class="form-control" type="number" min="0" v-model.number="item.prepTimeMinutes" placeholder="Valgfritt - brukes til smart hentetid" style="max-width: 300px;" />
            <span class="text-muted small">Sett antall minutter dette produktet tar å tilberede. Tilberedningstiden brukes til smartere beregning av hentetid.</span>
            <div v-if="item.prepTimeMinutes != null && item.prepTimeMinutes >= 0" class="mt-2">
              <label style="display: flex; align-items: center; gap: 8px;">
                <input type="checkbox" v-model="item.readyMade" style="width: 22px; height: 22px;" />
                Hyllevare/Ferdiglaget (f.eks. brus — påvirkes ikke av kjøkkenkø)
              </label>
            </div>
          </div>

          <div v-if="(item.itemType == 'DISH' || item.itemType == 'DRINK_BUBBLE_TEA') && showSpicyLevelSelections()">
            <span class="bo_label">Angi de mulige valgene for sterkhetsgrad</span>
            <fieldset>
                <label v-for="(spicyLevel, index) in spicyLevels" :key="index" class="multiple-checkbox-label">
                  <input type="checkbox" :name="spicyLevel.name" :value="spicyLevel.name" @click="setSelectedSpicyLevels" class="multiple-checkbox" /> {{ spicyLevel.name }}
                </label>
            </fieldset>
          </div>

          </div>
        </div>
      </div>
      <div v-if="!panelMode" class="col-md">
        <div class="buttonbar">
          <div class="button-panel">
            <button v-if="activateSaveButton" type="button" class="bo_btn" @click="saveItem"> Lagre produkt </button>
            <button v-else type="button" class="bo_btn" disabled="true"> Lagre produkt </button>
          </div>
        </div>
      </div>
    </div>
    <div v-if="panelMode" class="panel-sticky-footer">
      <button v-if="activateSaveButton" type="button" class="bo_btn" @click="saveItem"> Lagre produkt </button>
      <button v-else type="button" class="bo_btn" disabled="true"> Lagre produkt </button>
    </div>
  </div>
</template>

<script>
import LoadingSpinner from "@/components/other/LoadingSpinner";
import ProductService from "@/services/product/ProductService";
import MediaFileService from "@/services/media/MediaFileService";
import ImageCompressor from "@/util/ImageCompressor";
import ItemUtil from "@/util/ItemUtil";
import LocationUtil from "@/util/LocationUtil";
import ChannelUtil from "@/util/ChannelUtil";
import MerchantUtil from "@/util/MerchantUtil";
import MathUtil from "@/util/MathUtil";

export default {
  components: {LoadingSpinner},
  props: {
    panelMode: { type: Boolean, default: false },
    categoryIdProp: { type: String, default: '' }
  },
  emits: ['saved'],
  data() {
    return {
      loading: true,

      channels: ChannelUtil.CHANNELS, //one list with the channel line and filter on /products
      locations: [], //The availableAtLocationIds of the category decides which locations an item belonging to the category can be available at.
      allLocations: [], //All locations of the merchant, unfiltered
      orderTypes: [], //The availableForOrderTypes of the category decides which orderTypes an item belonging to the category can be available at.
      days: ["MONDAY", "TUESDAY","WEDNESDAY","THURSDAY","FRIDAY","SATURDAY","SUNDAY"],
      categoryId: '',
      category: {},
      categories: [],
      addOnGroups: [],
      addOnGroupId:'',
      spicyLevels: [],
      allergens: [],
      vat: {},
      imageFile: undefined,
      imageUrl: "",

      subselectionName: "",
      subselectionPrice: "",              //Takeaway price without VAT
      subselectionPriceWithVat: "",       //Takeaway price with VAT
      subselectionPriceDineIn: "",        //Dine-in price without VAT
      subselectionPriceDineInWithVat: "", //Dine-in price with VAT
      subselectionAddOnGroupIds: [],
      editingSubselectionId: null,

      price: 0,
      priceWithVat: "",
      //Blank, not 0, exactly like subselectionPriceDineIn above: an untouched field must stay
      //empty so the backend can tell "not entered" from "deliberately free". Storing 0 here is
      //what made a takeaway-only item render "kr 0 (med 25% mva for spise her)".
      priceDineIn: "",
      priceDineInWithVat: "",

      item: {
        type: "item",
        merchant: "",
        itemType: "",
        name: "",
        menuNr: "",
        availableAtLocationIds: [],
        availableForChannelIds: ['POS', 'KIOSK', 'WEB_DINE_IN', 'WEB_TAKEAWAY'], //default checked
        availableForOrderTypes: [],
        availableOnDays: ["MONDAY", "TUESDAY","WEDNESDAY","THURSDAY","FRIDAY","SATURDAY","SUNDAY"], //default checked
        showAsDiscount: false,
        openPrice: false,
        imageUrl: "",
        description: "",
        ingredientsText: "",
        categoryId: this.categoryId,
        subselections: [],
        price: 0,
        priceDineIn: "",
        addOnGroupIds: [],
        includedToppingsCount: 0,
        spicyLevelSelections: [],
        enableComment: false,
        allergens: [],
        prepTimeMinutes: null,
        readyMade: false,
        zipCodes: "", //Used for DELIVERY_SERVICE itemType, separated with comma, f.ex 2010,2044,
        sortOrder: -1
      }
    }
  },
  mounted() {
    if(this.showAvailableOnDaysHolidayOption){
      this.days.push("HOLIDAY");
    }

    this.categoryId = this.categoryIdProp || this.$route.query.categoryId;
    ProductService.getDataForItemAdminGui(this.categoryId).then(
        (response) => {
          let dataForGui = response.data;
          //console.log("dataForGui: " +  JSON.stringify(dataForGui));

          this.category = dataForGui.category;
          if(this.category.availableAtLocationIds === undefined){
            this.category.availableAtLocationIds = []; //init it
          }

          this.categories = dataForGui.categories;
          this.addOnGroups = dataForGui.addOnGroups;
          this.spicyLevels = dataForGui.spicyLevels;
          this.allergens = dataForGui.allergens;
          this.vat = dataForGui.vat;
          this.item.merchant = this.category.merchant;
          this.item.itemType = this.category.itemType;
          this.item.categoryId = this.categoryId;

          /*
           * The availableAtLocationIds of the category decides
           * which locations an item belonging to the category can be available at.
           */
          let allLocations = dataForGui.locations;
          this.allLocations = allLocations;
          for (let i = 0; i < this.category.availableAtLocationIds.length; i++) {
            let locationId = this.category.availableAtLocationIds[i];
            this.item.availableAtLocationIds.push(locationId); //All available locations selected by default

            for (let l = 0; l < allLocations.length; l++) {
              let location = allLocations[l];
              if (location.id === locationId) {
                this.locations.push(location);
                break;
              }
            }
          }

          /*
           * The availableForOrderTypes of the category decides
           * which orderTypes an item belonging to the category can be available for.
           */
          for (let i = 0; i < this.category.availableForOrderTypes.length; i++) {
            let orderType = this.category.availableForOrderTypes[i];
            this.item.availableForOrderTypes.push(orderType); //All available orderTypes selected by default
            this.orderTypes.push(orderType);
          }

          /*
           * Set default channel availability based on category's availableForChannelIds
           */
          if (this.category.availableForChannelIds && this.category.availableForChannelIds.length > 0) {
            this.item.availableForChannelIds = [...this.category.availableForChannelIds];
          }

          this.loading = false;
        },
        (error) => {
          console.log(error);
        }
    );
  },
  computed: {
    /**
     * Which price forms to show, from the order types ticked under "Tilgjengelig for". An item sold
     * takeaway only should not be asked for a dine-in price at all — leaving that field visible is what
     * got it filled with a meaningless 0 and rendered as "kr 0" on the products page.
     *
     * No order types selected means old data predating the field, or a form the merchant has not reached
     * yet: show both rather than hide a price they may need to enter.
     */
    selectedOrderTypes(){
      let orderTypes = this.item.availableForOrderTypes;
      return Array.isArray(orderTypes) ? orderTypes : [];
    },
    showTakeawayPriceFields(){
      return this.selectedOrderTypes.length === 0 || this.selectedOrderTypes.indexOf('TAKEAWAY') > -1;
    },
    showDineInPriceFields(){
      let merchantSellsDineIn = this.useFunctionality === 'POS' || this.useFunctionality === 'KIOSK_TAKEAWAY'
          || this.useFunctionality === 'ALL' || this.websiteShowDineInMenu;
      if(!merchantSellsDineIn){
        return false;
      }
      return this.selectedOrderTypes.length === 0 || this.selectedOrderTypes.indexOf('DINE_IN') > -1;
    },
    dineInPriceSuggestion(){
      //Suggest the same base price as takeaway, the gross price differs because of the VAT difference
      if(this.item.openPrice || this.price === "" || Number(this.price) <= 0){
        return null;
      }
      if(Number(this.price) === Number(this.priceDineIn)){
        return null; //Already the same base price
      }
      return Number(this.price);
    },
    dineInPriceSuggestionWithVat(){
      return ItemUtil.getPriceDineIn(this.dineInPriceSuggestion || 0, this.vat);
    },
    subselectionDineInPriceSuggestion(){
      if(this.subselectionPrice === "" || Number(this.subselectionPrice) <= 0){
        return null;
      }
      if(this.editingSubselectionId != null){
        //Editing an existing variant, only suggest when the dine-in price has not been filled in yet
        if(Number(this.subselectionPriceDineIn) > 0){
          return null;
        }
      } else if(Number(this.subselectionPrice) === Number(this.subselectionPriceDineIn)){
        return null; //Already the same base price
      }
      return Number(this.subselectionPrice);
    },
    subselectionDineInPriceSuggestionWithVat(){
      return ItemUtil.getPriceDineIn(this.subselectionDineInPriceSuggestion || 0, this.vat);
    },
    allLocationsUseManualPickupTime(){
      //Prep time is only used by the smart pickup time calculation, so the prep
      //time field is hidden when every location uses manual pickup/delivery time.
      return this.allLocations.length > 0 && this.allLocations.every(location => location.useManualPickupOrDeliveryTime === true);
    },
    showAvailabilitySection(){
      return this.hasMultiLocations() || this.showAvailableForChannels() || this.showAvailableForOrderTypes()
          || this.showAvailableOnDays() || this.enableShowAsDiscount();
    },
    showOtherSection(){
      return (!this.allLocationsUseManualPickupTime && this.item.itemType && this.item.itemType != 'DELIVERY_SERVICE')
          || ((this.item.itemType == 'DISH' || this.item.itemType == 'DRINK_BUBBLE_TEA') && this.showSpicyLevelSelections());
    },
    useFunctionality(){
      return MerchantUtil.useFunctionality();
    },
    useAddOns(){
      return MerchantUtil.useAddOns();
    },
    showAvailableOnDaysHolidayOption(){
      return MerchantUtil.showAvailableOnDaysHolidayOption();
    },
    websiteShowDineInMenu(){
      return MerchantUtil.websiteShowDineInMenu();
    },
    availableChannels(){
      if (!this.category.availableForChannelIds) {
        return [];
      }
      return this.channels.filter(channel => 
        this.category.availableForChannelIds.includes(channel.id)
      );
    },
    activateAddSubselectionButton() {
      if(this.subselectionName.length > 0 && (this.subselectionPrice > 0 || this.subselectionPriceDineIn > 0)){
          return true;
      } else {
          return false;
      }
    },
    activateSaveButton(){
      if(this.item.name.length === 0){
        return false;
      }
      //Variants carry the prices for these two, so the item itself needs none.
      if(this.item.itemType == 'DISH' || this.item.itemType == 'DRINK_BUBBLE_TEA'){
        return true;
      }
      //"Åpen pris": the cashier enters the amount at sale time, and onOpenPriceChanged zeroes every
      //price field on purpose. Requiring a price here is unsatisfiable by design.
      if(this.item.openPrice){
        return true;
      }
      //Rendered with its own dine-in VAT in a branch of its own, so its field is always on screen.
      if(this.item.itemType == 'DELIVERY_SERVICE'){
        return Number(this.priceDineIn) > 0;
      }
      //DRINK, ADD_ON, DRINK_ALCOHOL must carry a price — but it has to be one the form actually
      //SHOWS. Demanding a hidden field leaves the button permanently disabled with nothing the user
      //can do about it: a category limited to DINE_IN hides the takeaway price (showTakeawayPriceFields),
      //and alcohol never has one at all, yet both used to be validated against exactly that field.
      //So: require the takeaway price where it is offered, otherwise the dine-in price.
      if(this.showTakeawayPriceFields && this.item.itemType != 'DRINK_ALCOHOL'){
        return Number(this.price) > 0;
      }
      if(this.showDineInPriceFields){
        return Number(this.priceDineIn) > 0;
      }
      //No price field is on screen at all — the form cannot express one, so it must not be the thing
      //that blocks saving.
      return true;
    }
  },
  methods: {
    getOrderTypeName(orderType){
      if(orderType === 'DINE_IN'){
        return 'Spise Her';
      } else if(orderType === 'TAKEAWAY'){
        return 'Takeaway';
      }
    },
    hasMultiLocations(){
      return LocationUtil.hasMultiLocations();
    },
    showAvailableForChannels(){
      if(MerchantUtil.useFunctionality() === 'POS' || MerchantUtil.useFunctionality() === 'KIOSK_TAKEAWAY' || MerchantUtil.useFunctionality() === 'ALL' || MerchantUtil.websiteShowDineInMenu()){
        return true;
      }else {
        return false;
      }
    },
    showAvailableForOrderTypes(){
      if(MerchantUtil.useFunctionality() === 'POS' || MerchantUtil.useFunctionality === 'KIOSK_TAKEAWAY' || MerchantUtil.useFunctionality() === 'ALL' || MerchantUtil.websiteShowDineInMenu()){
        return true;
      }else {
        return false;
      }
    },
    showAvailableOnDays(){
      if((this.item.itemType == 'DISH' || this.item.itemType == 'DRINK_BUBBLE_TEA' ||
          this.item.itemType == 'DRINK') && MerchantUtil.showAvailableOnDays()){
        return true;
      }else {
        return false;
      }
    },
    enableShowAsDiscount(){
      if((this.item.itemType == 'DISH' || this.item.itemType == 'DRINK_BUBBLE_TEA' ||
          this.item.itemType == 'DRINK') && MerchantUtil.enableShowAsDiscount()){
        return true;
      }else {
        return false;
      }
    },
    enableOpenPrice(){
      //Open price is only for merchants with a POS, where the cashier enters the price at sale time
      if(this.useFunctionality !== 'POS' && this.useFunctionality !== 'ALL'){
        return false;
      }
      if(this.item.itemType == 'DISH' || this.item.itemType == 'DRINK_BUBBLE_TEA' ||
          this.item.itemType == 'DRINK'){
        return true;
      }else {
        return false;
      }
    },
    showSpicyLevelSelections(){
      return MerchantUtil.showSpicyLevelSelections();
    },
    setSelectedLocations(event){
      //console.log(JSON.stringify(this.item.availableAtLocationIds));
      let locationId = event.target.value;
      if(event.target.checked){
        this.item.availableAtLocationIds.push(locationId);
      } else {
        for (let i=0; i < this.item.availableAtLocationIds.length; i++){
          if (this.item.availableAtLocationIds[i] === locationId) {
            this.item.availableAtLocationIds.splice(i,1);
            break;
          }
        }
      }
      //console.log(JSON.stringify(this.item.availableAtLocationIds));
    },
    setSelectedChannels(event){
      //console.log(JSON.stringify(this.item.availableForChannelIds));
      let channelId = event.target.value;
      if(event.target.checked){
        this.item.availableForChannelIds.push(channelId);
      } else {
        for (let i=0; i < this.item.availableForChannelIds.length; i++){
          if (this.item.availableForChannelIds[i] == channelId) {
            this.item.availableForChannelIds.splice(i,1);
            break;
          }
        }
      }
      //console.log(JSON.stringify(this.item.availableForChannelIds));
    },
    setSelectedOrderTypes(event){
      //console.log(JSON.stringify(this.item.availableForOrderTypes));
      let orderType = event.target.value;
      if(event.target.checked){
        this.item.availableForOrderTypes.push(orderType);
      } else {
        for (let i=0; i < this.item.availableForOrderTypes.length; i++){
          if (this.item.availableForOrderTypes[i] === orderType) {
            this.item.availableForOrderTypes.splice(i,1);
            break;
          }
        }
      }
      //console.log(JSON.stringify(this.item.availableForOrderTypes));
    },
    getDayName(day){
      if(day === 'MONDAY'){
        return 'Mandag';
      } else if(day == 'TUESDAY'){
        return 'Tirsdag';
      } else if(day == 'WEDNESDAY'){
        return 'Onsdag';
      } else if(day == 'THURSDAY'){
        return 'Torsdag';
      } else if(day == 'FRIDAY'){
        return 'Fredag';
      } else if(day == 'SATURDAY'){
        return 'Lørdag';
      } else if(day == 'SUNDAY'){
        return 'Søndag';
      } else if(day == 'HOLIDAY'){
        return 'Hellig dag';
      }
      return 'DAY_NOT_DEFINED';
    },
    setSelectedDays(event){
      //console.log(JSON.stringify(this.item.availableOnDays));
      let day = event.target.value;
      if(event.target.checked){
        this.item.availableOnDays.push(day);
      } else {
        for (let i=0; i < this.item.availableOnDays.length; i++){
          if (this.item.availableOnDays[i] === day) {
            this.item.availableOnDays.splice(i,1);
            break;
          }
        }
      }
    },
    updatePrice(){
      this.price = ItemUtil.getPriceWithoutVat(this.vat.takeOut, this.priceWithVat);
    },
    updatePriceWithVat(){
      let priceWithVat = this.price + (this.price / 100 * this.vat.takeOut);
      this.priceWithVat = Math.round(priceWithVat);
    },
    updatePriceDineIn(){
       this.priceDineIn = ItemUtil.getPriceWithoutVat(this.vat.dineIn, this.priceDineInWithVat);
    },
    applyDineInPriceSuggestion(){
      this.priceDineIn = Number(this.price);
      this.updatePriceDineInWithVat();
    },
    applySubselectionDineInPriceSuggestion(){
      this.subselectionPriceDineIn = Number(this.subselectionPrice);
      this.updateSubselectionPriceDineInWithVat();
    },
    onOpenPriceChanged(){
      if(this.item.openPrice){
        //Open price items get their price entered at the point of sale
        this.price = 0;
        this.priceWithVat = 0;
        this.priceDineIn = 0;
        this.priceDineInWithVat = 0;
      }
    },
    updatePriceDineInWithVat(){
      let priceWithVat = this.priceDineIn + (this.priceDineIn / 100 * this.vat.dineIn);
      this.priceDineInWithVat = Math.round(priceWithVat);
    },

    //Prices for subselection
    updateSubselectionPricesWithVat(){
      let priceWithVat = this.subselectionPrice + (this.subselectionPrice / 100 * this.vat.takeOut);
      this.subselectionPriceWithVat = Math.round(priceWithVat);

      let priceDineInWithVat = this.subselectionPriceDineIn + (this.subselectionPriceDineIn / 100 * this.vat.dineIn);
      this.subselectionPriceDineInWithVat = Math.round(priceDineInWithVat);
    },
    updateSubselectionPriceDineInWithVat(){
      let priceWithVat = this.subselectionPriceDineIn + (this.subselectionPriceDineIn / 100 * this.vat.dineIn);
      this.subselectionPriceDineInWithVat = Math.round(priceWithVat);
    },
    updateSubselectionPriceWithVat(){
      let priceWithVat = this.subselectionPrice + (this.subselectionPrice / 100 * this.vat.takeOut);
      this.subselectionPriceWithVat = Math.round(priceWithVat);
    },
    updateSubselectionPrice(){
      this.subselectionPrice = ItemUtil.getPriceWithoutVat(this.vat.takeOut, this.subselectionPriceWithVat);
    },
    updateSubselectionPriceDineIn(){
      this.subselectionPriceDineIn = ItemUtil.getPriceWithoutVat(this.vat.dineIn, this.subselectionPriceDineInWithVat);
    },
    //End prices for subselection

    selectFile(){
      let file = this.$refs.file.files[0];
      ImageCompressor.compressImageToWebp(file).then((compressed) => {
        this.imageFile = compressed;
        console.log("imageFile: " + this.imageFile.name);
      }).catch((error) => {
        console.log("Image compression failed, using original: " + error.message);
        this.imageFile = file;
      });
    },
    removeSubselection(subselection){
      for (let i =0; i < this.item.subselections.length; i++){
        if (this.item.subselections[i].name == subselection.name && this.item.subselections[i].price == subselection.price) {
          this.item.subselections.splice(i,1);
          break;
        }
      }
    },
    addSubselection(){
      let subselection = {
        id : MathUtil.createUUID(),
        name: this.subselectionName,
        price: this.subselectionPrice,
        priceDineIn: this.subselectionPriceDineIn,
        addOnGroupIds: Object.assign([], this.subselectionAddOnGroupIds) //Array is passed by reference
      };
      this.item.subselections.push(subselection);
      this.resetSubselection();
    },
    saveSubselection(){
      this.item.subselections.find((subselection) => {
        if(subselection.id == this.editingSubselectionId){
          subselection.name = this.subselectionName;
          subselection.price = this.subselectionPrice;
          subselection.priceDineIn = this.subselectionPriceDineIn;
          subselection.addOnGroupIds = Object.assign([], this.subselectionAddOnGroupIds); //Array is passed by reference
        }
      });

      this.resetSubselection();
      this.editingSubselectionId = null;
      //console.log('item.subselections: ' + JSON.stringify(this.item.subselections));
    },
    editSubselection(subselection){
      this.editingSubselectionId = subselection.id;
      this.subselectionName = subselection.name;
      this.subselectionPrice = subselection.price;
      this.subselectionPriceDineIn = subselection.priceDineIn;
      this.subselectionAddOnGroupIds = subselection.addOnGroupIds;
      this.updateSubselectionPricesWithVat();
    },
    cancelEditingSubselection(){
      this.editingSubselectionId = null;
      this.resetSubselection();
    },
    resetSubselection(){
      this.subselectionName = "";
      this.subselectionPrice = "";
      this.subselectionPriceWithVat = "";
      this.subselectionPriceDineIn = "";
      this.subselectionPriceDineInWithVat = "";
      this.subselectionAddOnGroupIds = [];
    },
    setSelectedAddOnGroups(event){
      let addOnGroupId = event.target.value;
      if(this.item.addOnGroupIds.length == 0){
        this.item.addOnGroupIds.push(addOnGroupId);
      } else {
        for (let i = 0; i < this.item.addOnGroupIds.length; i++){
          if (this.item.addOnGroupIds[i] === addOnGroupId) {
            this.item.addOnGroupIds.splice(i,1);
            break;
          }
        }
      }
    },
    setSelectedSpicyLevels(event){
      let spiceLevelName = event.target.value;
      if(event.target.checked){
        this.item.spicyLevelSelections.push(spiceLevelName);
      } else {
        for (var i=0; i < this.item.spicyLevelSelections.length; i++){
          if (this.item.spicyLevelSelections[i] === spiceLevelName) {
            this.item.spicyLevelSelections.splice(i,1);
            break;
          }
        }
      }
    },
    setSelectedAllergens(event){
        //console.log(JSON.stringify(item.allergens));
        let allergenJson = JSON.parse(event.target.value);
        if(event.target.checked){
          this.item.allergens.push(allergenJson);
        } else {
          for (var i=0; i < this.item.allergens.length; i++){
            if (this.item.allergens[i].name === allergenJson.name && this.item.allergens[i].imageUrl === allergenJson.imageUrl) {
              this.item.allergens.splice(i,1);
              break;
            }
          }
        }
    },
    setSelectedSubselectionAddOnGroupIds(event){
      let addOnGroupId = event.target.value;
      if(event.target.checked){
        this.subselectionAddOnGroupIds.push(addOnGroupId);
      } else {
        for (let i = 0; i < this.subselectionAddOnGroupIds.length; i++){
          if (this.subselectionAddOnGroupIds[i] == addOnGroupId) {
            this.subselectionAddOnGroupIds.splice(i,1);
            break;
          }
        }
      }
    },
    setSelectedItemAddOnGroupIds(event){
      let addOnGroupId = event.target.value;
      if(event.target.checked){
        this.item.addOnGroupIds.push(addOnGroupId);
      } else {
        for (let i = 0; i < this.item.addOnGroupIds.length; i++){
          if (this.item.addOnGroupIds[i] == addOnGroupId) {
            this.item.addOnGroupIds.splice(i,1);
            break;
          }
        }
      }
    },
    getAddOnGroup(addOnGroupId){
      for (let i = 0; i < this.addOnGroups.length; i++){
        let addOnGroup = this.addOnGroups[i];
        if (addOnGroup.id == addOnGroupId) {
            return addOnGroup;
        }
      }
      return undefined;
    },
    getPriceWithVat(priceWithoutVat){
      return ItemUtil.getPriceWithVat(priceWithoutVat, this.vat);
    },
    getPriceDineIn(priceWithoutVat){
      return ItemUtil.getPriceDineIn(priceWithoutVat, this.vat);
    },
    saveItem(){
      this.loading = true;
      //Updating item properties
      this.item.price = this.price;
      this.item.priceDineIn = this.priceDineIn;
      //console.log(JSON.stringify(this.item));
      if(this.imageFile){
        MediaFileService.uploadImageFile(this.imageFile).then(
            (response) => {
              let imageUrl = response.data;
              if(imageUrl){
                //console.log("imageUrl: " + imageUrl);
                this.item.imageUrl = imageUrl;
                this.createItem(this.item);
              } else {
                console.log("Uploading image failed");
              }
              this.loading = false;
            },
            (error) => {
              console.log(error);
            }
        );
      } else {
        this.createItem(this.item);
      }
    },
    createItem(item){
      ProductService.createItem(item).then(
          (response) => {
            let documentId = response.data;
            if(documentId){
              if(this.panelMode){ this.$emit('saved'); } else { this.$router.push({ path: 'products'}); }
            } else {
              console.log("Creating item failed");
            }
            this.loading = false;
          },
          (error) => {
            console.log(error);
          }
      );
    }
  }
}
</script>

<style scoped>

.button-panel {
  border-radius: 5px;
  border: 2px solid var(--bo-surface-2);
  padding: 17px 17px 17px 17px;
  background-color: var(--bo-surface-2);
  margin-bottom: 20px;
}

/**
 * lg: 992px breakpoint or larger
 */
@media screen and (min-width: 992px) {
  .buttonbar {
    position: sticky;
    /* Rendered only when NOT in a side panel (v-if="!panelMode"), so the window is what scrolls here
       and the pinned navbar is in the way. */
    top: calc(var(--bo-nav-offset, 0px) + 10px);
    margin-top: 35px;
  }
}

.panel-sticky-footer {
  position: sticky;
  bottom: 0;
  background-color: var(--bo-surface);
  border-top: 1px solid var(--bo-line);
  padding: 15px 20px;
  z-index: 10;
}

</style>
